// extracted by mini-css-extract-plugin
module.exports = {"padding_compensate":"CategoryNav_padding_compensate__XsW8L"};